export default __webpack_public_path__ + "static/media/Delete.626964a9.svg";